import { computed, ref } from 'vue';

// BonBoZ: chế độ của bộ lọc ngày — bảng lọc GHI, thẻ hội thoại ĐỌC.
//
// Không chuyền prop vì đường đi là ChatList -> ConversationList ->
// ConversationCard -> TimeAgo: bốn tầng chỉ để cõng một cờ boolean, và ba tầng
// giữa không dùng tới nó. Cũng không để trong Vuex: trạng thái này chết theo
// phiên làm việc, server không biết tới, và không hành động nào của server
// chạm vào.
export const DATE_FILTER_MODES = Object.freeze({
  // TIN MỚI NHẤT khách thấy được nằm trong khoảng (mặc định)
  UPDATED: 'updated',
  // Hội thoại BẮT ĐẦU trong khoảng
  CREATED: 'created',
});

// Suy trạng thái huy hiệu TỪ CHÍNH truy vấn danh sách đang dùng.
//
// Trước đây nó bám theo nút sáng ở thanh lọc. Thanh lọc bị dựng lại khi đổi
// route, còn trạng thái này sống ở module nên không chết theo — dựng lại xong
// nút đã rỗng sẵn, lệnh tắt không đổi giá trị nào nên watcher không chạy và
// huy hiệu kẹt lại vĩnh viễn. Truy vấn thì luôn là sự thật: có mốc ngày trong
// đó nghĩa là danh sách đang lọc theo ngày, không cần hỏi ai.
export const dateFilterFromQuery = query => ({
  mode: query?.dateField || DATE_FILTER_MODES.UPDATED,
  active: Boolean(query?.activityAfter || query?.activityBefore),
});

const mode = ref(DATE_FILTER_MODES.UPDATED);
const isActive = ref(false);

export function useDateFilterMode() {
  return {
    dateFilterMode: computed(() => mode.value),

    // Thẻ hội thoại chỉ khoe mốc "giờ tạo" khi bộ lọc ngày ĐANG BẬT và đang
    // tính theo ngày tạo — lúc đó con số mới giải thích được vì sao hội thoại
    // này lọt vào kết quả. Ngoài lúc đó nó chỉ làm chật dòng.
    showCreatedAt: computed(
      () => isActive.value && mode.value === DATE_FILTER_MODES.CREATED
    ),

    // Card shows the latest customer-visible message time, the same moment the
    // "updated" filter matched on (last activity also counts notes, activity lines).
    showLastVisibleMessageAt: computed(
      () => isActive.value && mode.value === DATE_FILTER_MODES.UPDATED
    ),

    setDateFilter: (nextMode, active) => {
      mode.value = nextMode;
      isActive.value = active;
    },
  };
}
